import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/FileMdColor.tsx
const FileMdColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "m15.897 2 5.6 5.687v12.25c0 1.692-1.333 3.063-2.978 3.063H7.029c-1.645 0-2.978-1.371-2.978-3.062V5.062C4.05 3.371 5.384 2 7.029 2h8.868Z",
			fill: "url(#paint0_linear_1088_2032)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m18.733 4.844 2.766 2.843v4.375L16.392 7.25l2.34-2.406Z",
			fill: "url(#paint1_linear_1088_2032)",
			fillOpacity: .3
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.499 7.688h-4.256c-.705 0-1.346-.588-1.346-1.313V2L21.5 7.688Z",
			fill: "#307BEC"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M1.5 12.588c0-1.208.953-2.188 2.128-2.188H12.5c1.175 0 2.128.98 2.128 2.188v5.687c0 1.209-.953 2.188-2.128 2.188H3.628c-1.175 0-2.128-.98-2.128-2.188v-5.687Z",
			fill: "url(#paint2_linear_1088_2032)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.5 10.4c1.175 0 2.128.98 2.128 2.188 0-1.087-.953-1.969-2.128-1.969H3.628c-1.175 0-2.128.882-2.128 1.969 0-1.208.953-2.188 2.128-2.188H12.5Z",
			fill: "#fff",
			fillOpacity: .7
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M10.747 17.95H9.004V13h1.764c1.49 0 2.402.926 2.399 2.468.003 1.548-.91 2.481-2.42 2.481Zm-.718-.883h.677c.943 0 1.436-.488 1.436-1.6 0-1.1-.493-1.585-1.43-1.585h-.683v3.185ZM3.102 13h1.271l1.374 3.356h.055L7.176 13h1.271v4.95H7.45v-3.241h-.04l-1.293 3.22h-.683L4.14 14.695H4.1v3.254h-.998V13Z",
			fill: "#EFF9FF"
		}),
		/* @__PURE__ */ jsxs("defs", { children: [
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint0_linear_1088_2032",
				x1: 12.774,
				y1: 2,
				x2: 12.774,
				y2: 23,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#98CBFF" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#5F97FF"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint1_linear_1088_2032",
				x1: 18.945,
				y1: 4.844,
				x2: 18.945,
				y2: 12.063,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#0B60CE" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#7EB3FF"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint2_linear_1088_2032",
				x1: 8.064,
				y1: 10.4,
				x2: 8.064,
				y2: 20.463,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#4D90ED" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#3562D3"
				})]
			})
		] })
	]
}));
//#endregion
export { FileMdColorIcon };
